import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './Signature.module.css';
import { Checkbox } from '../../../../components/Checkbox/Checkbox';
import { SignatureInput } from '../../../../components/SignatureInput';
import { ReportFooter } from '../views';
import { Button } from '../../../../components/Button';
import {
  saveReportForLater,
  setLogbookFormState,
  setLogbookPage,
  submitLogbook,
  useLogbookFormState,
} from '../../../../services/logbook';

export const Signature: FC = () => {
  const state = useLogbookFormState();
  const [checked, setChecked] = useState(false);

  return (
    <>
      <div className={styles.root}>
        <SignatureInput
          filename="timeline"
          onChange={(signature) => setLogbookFormState({ ...state, signature })}
          onClear={() => setLogbookFormState({ ...state, signature: null })}
          value={state.signature ?? undefined}
        />
        <div className="light">
          <FormattedMessage id="Logbook.Disclamer" />
        </div>
        <label className={styles.confirm}>
          <Checkbox
            className={styles.checkbox}
            checked={checked}
            onChange={(e) => setChecked(e.currentTarget.checked)}
          />
          <FormattedMessage id="Logbook.Confirm" tagName="div" />
        </label>
      </div>
      <ReportFooter>
        <Button
          grow
          disabled={!state.signature || !checked}
          onClick={submitLogbook}
        >
          <FormattedMessage id="Submit" />
        </Button>
        <Button variant="text" grow onClick={() => saveReportForLater()}>
          <FormattedMessage id="SaveForLater" />
        </Button>
        <Button variant="text" grow onClick={() => setLogbookPage(2)}>
          <FormattedMessage id="Back" />
        </Button>
      </ReportFooter>
    </>
  );
};
